import { useState } from 'react';
import * as R from 'ramda';

import CreateWorkModal from '@atom/components/common/createWorkModal/CreateWorkModal';
import { usePreferences } from '@atom/hooks/usePreferences';
import { Icon, IconButton } from '@atom/mui';
import { AddIcon } from '@atom/mui/icons';
import { AssetDetail } from '@atom/types/asset';
import { WorkOrder } from '@atom/types/work';

import WorkRow from '../shared/WorkRow';

import sidebarClasses from '../shared/sidebars.module.css';
import classes from './asset.module.css';

export type AssetWorkTabProps = {
  asset: AssetDetail;
  workOrders: WorkOrder[];
};

const AssetWorkTab = ({ asset, workOrders }: AssetWorkTabProps) => {
  const preferences = usePreferences();
  const requireWorkType = R.pathOr(
    false,
    ['workOrders', 'requireWorkType'],
    preferences,
  );

  const [createOpen, setCreateOpen] = useState(false);

  return (
    <>
      <div className={sidebarClasses.workPanel}>
        <div className={classes.workHeading}>
          <span>{`${workOrders.length} work`}</span>
          <IconButton onClick={() => setCreateOpen(true)}>
            <Icon icon={AddIcon} />
          </IconButton>
        </div>
        <div className={sidebarClasses.workList}>
          {workOrders.map(workOrder => (
            <WorkRow key={workOrder.id} work={workOrder} />
          ))}
        </div>
      </div>
      <CreateWorkModal
        redirectOnCreate
        open={createOpen}
        onClose={() => setCreateOpen(false)}
        asset={asset}
        workTemplateRequired={requireWorkType}
      />
    </>
  );
};

export default AssetWorkTab;
